import EmptyLayout from '@/layouts/EmptyLayout.vue'

const Login = () => import('@/pages/access/Login.vue')

export default {
    path: '/access',
    component: EmptyLayout,
    children: [
        {
            path: '',
            name:'Авторизация',
            component: Login
        }
    ]
}